export default __webpack_public_path__ + "static/media/mob_lk_1280.4d7d6bc7.webp";